(ns hai.web-app.components
  "General HumbleAI web app (the concept) components"
  (:require
   [hai.ui.components :as c]
   [hai.ui.components.spinners :as spinners]
   [hai.ui.components.page-not-found :as page-not-found]
   [lambdaisland.ornament :as o]
   [hai.ui.tokens :as t]))

(comment
  ;; necessary import to trigger clj compilation
  page-not-found/full-page
  )

(defn full-center [body]
  [c/Flex {:direction "column" :justify "center" :height "100vh"}
   [c/Flex {:direction "row" :justify "center"}
    body]])

(o/defstyled humble-brand :div
  :font-bold :flex :items-center :text-5xl :gap-2
  :tracking-tighter
  {:color t/--humble-primary-dark}
  [:img {:width "64px" :height "64px" :border-radius "12px"}]
  ([]
   [:<>
    [:img {:src "/imgs/humble-avatar-blink.gif"
           :alt "Humble AI"}]
    "Humble"]))

(o/defstyled humble-loader :div
  ([]
   [:<>
    [humble-brand]
    [spinners/pulse-dots]]))
